import React from 'react';
import Select from '../../../components/ui/Select';

const SortDropdown = ({ value, onChange }) => {
  const sortOptions = [
    { value: 'match', label: 'Best Match' },
    { value: 'recent', label: 'Most Recent' },
    { value: 'urgent', label: 'Most Urgent' },
    { value: 'impact', label: 'Highest Impact' },
    { value: 'distance', label: 'Nearest Location' },
    { value: 'spots', label: 'Spots Available' }
  ];

  return (
    <div className="w-full sm:w-64">
      <Select
        label="Sort by"
        options={sortOptions}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default SortDropdown;